import { Pipe, PipeTransform } from 'angular-ts-decorators';

export interface IAddress {
  street?: string;
  houseno?: string;
  houseadd?: string;
  city?: string;
  country?: string;
}

/**
 * Creates a human-readable string address object.
 * @param {IAddress} input object containing address
 * @return {string} address as a string
 */
@Pipe({ name: 'address' })
export class AddressPipe implements PipeTransform {
  constructor(private $translate: ng.translate.ITranslateService) {
    'ngInject';
  }

  public transform(input: IAddress): string {
    const address = [];
    let houseAdd;
    if (angular.isObject(input)) {
      if (input.street && !input.houseno) {
        address.push(input.street);
      } else if (input.street && input.houseno) {
        houseAdd = input.houseadd ? input.houseadd : '';
        address.push(input.street + ' ' + input.houseno + houseAdd);
      } else {
        address.push(this.$translate.instant('core.unknown'));
      }

      if (input.city) {
        address.push(input.city);
      } else {
        address.push(this.$translate.instant('core.unknown'));
      }

      if (input.country) {
        address.push(input.country);
      } else {
        address.push(this.$translate.instant('core.unknown'));
      }

      return address.join(', ');
    }
    return this.$translate.instant('core.unknown');
  }
}
